import { actionsPreprocessor } from '../../utils/redux';

const actionNames = [
  'FETCH_LEAD',
  'FETCH_SUCCESS',
  'FETCH_FAILED',

  'UPDATE_LEAD',
  'UPDATE_SUCCESS',
  'UPDATE_FAILED',

  'CHANGE_TAB',
  'SET_EDIT_MODE',
  'SAVE_EDIT_DATA',
  'CLEAR_EDIT_DATA',
  'FILL_LEAD_FIELDS',

  'DELETE_LEAD',
  'DELETE_SUCCESS',
  'DELETE_FAILED',

  'DELETE_FILE',
  'REDIRECT_TO_LEAD',

  'SYSTEM_IMAGE_UPLOAD',
  'REMOVE_SYSTEM_IMAGE',

  'FETCH_PROJECT_INFORMATION_DETAILS',
  'FETCH_PROJECT_INFORMATION_DETAILS_SUCCESS',
  'FETCH_PROJECT_INFORMATION_DETAILS_FAILED',

  'FETCH_DOCUMENT',
  'FETCH_DOCUMENT_SUCCESS',
  'FETCH_DOCUMENT_FAILED',

  'RESET_DOCUMENT_URL',
  'RESET_DOCUMENT_URL_SUCCESS',
  'RESET_DOCUMENT_URL_FAILED',
];

const { actions, actionTypes } = actionsPreprocessor('lead', actionNames);

export default actions;
export { actionTypes };
